<template>
	<div class="content-page content-page--company-settings">
		<ActionSetNav
			:name="companyLocalData.advanced.companyName"
			:display="true"
			:actions="mainNavActions"
		/>
		<div class="content-page__heading">
			<Breadcrumbs :items="urlNames" />
			<div class="content-page__breadcrumb-actions">
				<div class="content-page__breadcrumb-title">
					<h2 class="content-page__title">
						{{ companyLocalData.advanced.companyName }}
					</h2>
				</div>
				<div class="content-page__actions">
					<MenuButton
						:iconBeforeLabel="true"
						iconClassName="icon-more"
						:items="locationTypes"
						v-model="locationSelected"
					/>
				</div>
			</div>
		</div>
		<ScrollContainer
			class="content-page__content"
			:selectorArray="pageElements"
			:extraSpace="64"
		>
			<CompanyContent :data="companyLocalData" />
		</ScrollContainer>
	</div>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import MenuButton from '@/components/forms/button/menu-button';
import ScrollContainer from '@/components/shells/scroll-container/scroll-container';
import CompanyContent from './company-content.vue';

export default {
	name: 'CompanySettings',
	components: {
		ActionSetNav,
		Breadcrumbs,
		MenuButton,
		ScrollContainer,
		CompanyContent
	},
	data() {
		return {
			pageElements: [
				'header.site__header',
				'nav.action-set-nav',
				'footer.site__footer',
				'.content-page__heading'
			],
			companyLocalData: {},
			locationTypes: [
				{
					text: 'Parts',
					value: 'P'
				},
				{
					text: 'Sales',
					value: 'S'
				},
				{
					text: 'Service',
					value: 'V'
				}
			],
			locationSelected: { text: 'Add Location', value: '' },
			mainNavActions: [
				{
					id: 1,
					action: {
						name: 'company-settings'
					},
					title: 'Select to go to Company Settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: {
						name: 'error-log'
					},
					title: 'Select to go to Error Log',
					iconClass: 'icon icon-error',
					label: 'Error Log',
					type: 'route-link',
					visible: true
				},
				{
					id: 3,
					action: {
						name: 'integrations-manager'
					},
					iconClass: 'icon icon-customer-integration',
					label: 'Integration',
					title: 'Select to go to Client Integrations',
					type: 'route-link',
					visible: true
				},
				{
					id: 4,
					action: {
						name: 'transactions'
					},
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to Client Transactions',
					type: 'route-link',
					visible: true
				}
			],
			urlNames: [
				{
					name: 'Clients',
					data: {
						path: '/clients'
					}
				}
			]
		};
	},
	created() {
		this.companyLocalData = this.$route.params.company;
		this.urlNames.push({
			name: `${this.companyLocalData.advanced.companyName} Settings`
		});
	},
	methods: {
		createNewLocation() {
			console.log('Push New Location Route');
		}
	}
};
</script>

<style lang="scss" scoped>
/* UI/UX NOTE: PLEASE MAKE ADJUSTMENTS, THIS IS JUST FOR TEST */
.content-page {
	&__heading {
		display: flex;
		flex-direction: column;
		gap: $gutter-md;
	}

	&__breadcrumb-actions {
		display: flex;
		align-items: center;
	}
}
</style>
